/**
 * 获取参数值
 */
var GetParamValue={
		//获取产品对应的图片
		getProductPic:function(productName){
			var pic="";
			if(Number(productName) == 1){
				/*** 1、公司注册 ***/
				pic=require("../../assets/images/list/gszc.png");
			}else if(Number(productName) == 2){
				/*** 2、代理记账 ***/
				pic=require("../../assets/images/list/dljz.png");
			}else if(Number(productName) == 3){
				/*** 3、企业变更 ***/
				pic=require("../../assets/images/list/qybg.png");
			}else if(Number(productName) == 4){
				/*** 4、地址异常处理 ***/
				pic=require("../../assets/images/list/dzyccl.png");
			}else if(Number(productName) == 5){
				/*** 5、开设基本户 ***/
				pic=require("../../assets/images/list/ksjbh.png");
			}else if(Number(productName) == 6){
				/*** 6、公司注销 ***/
				pic=require("../../assets/images/list/gszx.png");
			}else if(Number(productName) == 7){
				/*** 7、税务筹划 ***/
				pic=require("../../assets/images/list/swch.png");
			}else if(Number(productName) == 8){
				/*** 8、发票申领 ***/
				pic=require("../../assets/images/list/fpsl.png");
			}else if(Number(productName) == 9){
				/*** 9、税务解非 ***/
				pic=require("../../assets/images/list/swjf.png");
			}else if(Number(productName) == 10){
				/*** 10、年度汇算清缴 ***/
				pic=require("../../assets/images/list/ndhsqj.png");
			}else if(Number(productName) == 11){
				/*** 11、年度工商年报 ***/
				pic=require("../../assets/images/list/ndgsnb.png");
			}else if(Number(productName) == 12){
				/*** 12、食品经营许可证 ***/
				pic=require("../../assets/images/list/spjyxkz.png");
			}else if(Number(productName) == 13){
				/*** 13、财税咨询 ***/
				pic=require("../../assets/images/list/cszx.png");
			}else if(Number(productName) == 14){
				/*** 14、香港公司注册 ***/
				pic=require("../../assets/images/list/xggszc.png");
			}else if(Number(productName) == 15){
				/*** 15、香港公司注销 ***/
				pic=require("../../assets/images/list/xggszx.png");
			}else if(Number(productName) == 16){
				/*** 16、开设一般户 ***/
				pic=require("../../assets/images/list/ksybh.png");
			}else if(Number(productName) == 17){
				/*** 17、刻章备案 ***/
				pic=require("../../assets/images/list/kzba.png");
			}else if(Number(productName) == 18){
				/*** 18、社保开户 ***/
				pic=require("../../assets/images/list/sbkh.png");
			}else if(Number(productName) == 19){
				/*** 19、开设公积金账户 ***/
				pic=require("../../assets/images/list/gjjzh.png");
			}else if(Number(productName) == 20){
				/*** 20、定制代记账方案 ***/
				pic=require("../../assets/images/list/dzdljz.png");
			}else if(Number(productName) == 21){
				/*** 21、旧账梳理 ***/
				pic=require("../../assets/images/list/jzsl.png");
			}else if(Number(productName) == 22){
				/*** 22、年报异常解非 ***/
				pic=require("../../assets/images/list/nbycjf.png");
			}else if(Number(productName) == 23){
				/*** 23、开票咨询 ***/
				pic=require("../../assets/images/list/kpzx.png");
			}else if(Number(productName) == 24){
				/*** 24、外勤上门服务 ***/
				pic=require("../../assets/images/list/wqsmfw.png");
			}else if(Number(productName) == 25){
				/*** 25、电商客服外包务 ***/
				pic=require("../../assets/images/list/kfwb.png");
			}else if(Number(productName) == 26){
				/*** 26、劳务派遣许可证 ***/
				pic=require("../../assets/images/list/lwpq.png");
			}else if(Number(productName) == 27){
				/*** 27、道路运输许可证 ***/
				pic=require("../../assets/images/list/ysxkz.png");
			}else if(Number(productName) == 28){
				/*** 28、游戏出版运营备案 ***/
				pic=require("../../assets/images/list/yxcb.png");
			}else if(Number(productName) == 29){
				/*** 29、ODI境外投资 ***/
				pic=require("../../assets/images/list/jwtz.png");
			}else if(Number(productName) == 99){
				/*** 99、套餐 ***/
				pic=require("../../assets/images/list/zuhe.png");
			}
			return pic;
		},
		//获取产品-纳税资质类型
		getQualificationType:function(qType){
			 var qualificationType='';
			 switch (qType) {
		     case 1:
		    	 qualificationType='一般纳税人；';
		         break;
		     case 2:
		    	 qualificationType='小规模纳税人；';
		         break;
		     default:
		    	 qualificationType='';
			 }
			 return qualificationType;
		},
		//获取产品-企业注册类型
		getAreaName:function(areaName){
			var area="";
			if(areaName == '' || areaName == null){
				return area;
			}else{
				return areaName+"；";
			}
		},
		//获取产品-企业注册类型
		getRegisterType:function(regType){
			var registerType="";
			switch (regType) {
		        case 1:
		        	registerType='个人独资；';
		            break;
		        case 2:
		        	registerType='企业合伙；';
		            break;
		        default:
		        	registerType='';
			}
			return registerType;
		},
		//获取产品-注册地址办理方式
		getRegisterAreaType:function(raType){
			 var registerAreaType="";
		     switch (raType) {
		         case 1:
		        	 registerAreaType='自行办理注册地址；';
		             break;
		         case 2:
		        	 registerAreaType='代办理注册地址；';
		             break;
		         default:
		        	 registerAreaType='';
		     }
		     return registerAreaType;
		},
		//获取产品-银行开户办理方式
		getBankType:function(bType){
			 var bankType='';
			 switch (bType) {
			 	case 1:
			 		bankType='自行办理银行开户；';
		            break;
		        case 2:
		        	bankType='代办理银行开户；';
		            break;
		        default:
		        	bankType='';
			 }
			 return bankType;
		},
		//获取产品-服务期限【代理记账】 1:三个月、2:半年、3:一年
		getServerTerm:function(sTerm){
		    var serverTerm = "";
		    switch (sTerm) {
		        case 1:
		        	serverTerm='三个月；';
		            break;
		        case 2:
		        	serverTerm='半年；';
		            break;
		        case 3:
		        	serverTerm='一年；';
		            break;
		        default:
		        	serverTerm='';
		    }
		    return serverTerm;
		},
		
		//获取产品-变更选择【代理记账】
		getChangeChoose:function(changeChoose,pName,registerType,serverTerm){
			var choose="";
			if(changeChoose == '' || changeChoose == null){
				return choose;
			}else{
				return "含\""+changeChoose+"\"变更；";
			}
		},
		//获取产品-行业类型
		getIndustryType:function(industryType){
			var industry="";
			if(industryType == '' || industryType == null || industryType == 0){
				return industry;
			}else{
				return "电商行业型；";
			}
		},
		//获取产品-业务类型
		getBusinessType:function(businessType){
			var business="";
			if(businessType == '' || businessType == null){
				return business;
			}else{
				return businessType+"；";
			}
		},
}

export{
	GetParamValue
}